import { i18n } from 'invision-core';
import LocaleKeys from '../../locales/keys';
export var ACCEPTING_FOR = {
  CHILD: 'child',
  MYSELF: 'myself'
};
export var CONSENT_TYPES = {
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional'
};
export var CUSTOMER_CATEGORY = {
  RESIDENTIAL: 0,
  COMMERCIAL: 1
};
export var INVOICE_DELIVERY_METHODS = {
  INVOICE: '12'
};
export var CustomerCategories = function CustomerCategories() {
  return [{
    id: CUSTOMER_CATEGORY.RESIDENTIAL,
    value: i18n.translate(LocaleKeys.RESIDENTIAL)
  }, {
    id: CUSTOMER_CATEGORY.COMMERCIAL,
    value: i18n.translate(LocaleKeys.COMMERCIAL)
  }];
};
export var NO_SUBTENANTS = '0';
export var HierarchyNodeType = {
  REGULAR: 1,
  INHERITED: 2
};
export var SUBSCRIBER_ADJUSTMENT_DUE_DAYS_LIMITS = {
  min: -1,
  max: 1000
};
export var SUBSCRIBER_PAYMENT_DUE_DAYS_LIMITS = {
  min: 0,
  max: 1000
};
export var ADJUSTMENT_DUE_DAYS = 'adjustment_due_days';
export var PAYMENT_DUE_DAYS = 'payment_due_days';
export var OPT_OUT_OPTIONS = {
  OPT_OUT_EMAIL: 1,
  OPT_OUT_SMS: 2
};